import { createContext } from 'react';

let contextInstance;

const getContextInstance = () => {
    if (contextInstance) {
        return contextInstance;
    }

    contextInstance = createContext({});
    contextInstance.displayName = 'TranslationContext';

    return contextInstance;
};

export default getContextInstance();
